import { Link } from "react-router-dom";
import { Wordmark } from "@/components/landing/Wordmark";
import { cn } from "@/lib/utils";

type HomeLinkProps = {
  className?: string;
};

export const HomeLink = ({ className }: HomeLinkProps) => (
  <div className={cn("flex items-center justify-between gap-3", className)}>
    <Wordmark to="/app" size="sm" />
    <Link
      to="/app"
      className="text-label text-blue-600 underline-offset-4 hover:underline"
    >
      Voltar ao início
    </Link>
  </div>
);
